import { colors } from "assets";

export default `
  display: inline-block;
  a{
    margin: 2px 0px;
    color: ${colors.link.normal};
    cursor: pointer;
    &:hover{
      color: ${colors.link.dark};
    }
  }

`;



// WEBPACK FOOTER //
// ./src/components/support/link/styles.js